<template>
  <common-report-card
    :configs="configs"
    :cardTitle="'Báo cáo tiến độ hoàn thành công việc'"
    @viewReportDetail="viewReportDetail"
  ></common-report-card>
</template>

<script>
import constants from "../../constants";
import utils from "../../services/utils";
import CommonReportCard from "./common-report-card";
import h from "../../services/h";

export default {
  name: "tk-report-card",
  props: ["menuConfigs"],
  components: {
    CommonReportCard,
  },
  data() {
    return {
      configs: []
    };
  },

  created() {
    this.initConfigs();
  },

  methods: {

    isEnableMenu(menuCode) {
      return h.exists(this.menuConfigs, item => item.menuCode === menuCode);
    },

    initConfigs() {
      this.configs = [];
      (this.isEnableMenu(constants.MENU_LIST.BAOCAO_QLCV_TIENDOHOANTHANHCV)) && (
        this.configs.push({
          title: "Báo cáo tiến độ hoàn thành công việc",
          reportType: constants.REPORT.QLCV.TYPE.BAOCAOTIENDOHOANTHANHCV
        })
      );

      (this.isEnableMenu(constants.MENU_LIST.BAOCAO_QLCV_TONGHOPTHANG)) && (
        this.configs.push({
          title: "Báo cáo đánh giá tổng hợp tháng",
          reportType: constants.REPORT.QLCV.TYPE.BAOCAOTONGHOPTHANG
        })
      );

      (this.isEnableMenu(constants.MENU_LIST.BAOCAO_QLCV_RANKING_TONGHOP)) && (
        this.configs.push({
          title: constants.MENU_LIST.BAOCAO_QLCV_RANKING_TONGHOP,
          reportType: constants.REPORT.QLCV.TYPE.RANKING_TONGHOP
        })
      );

      (this.isEnableMenu(constants.MENU_LIST.BAOCAO_QLCV_RANKING_TRUNGBINHTHANG)) && (
        this.configs.push({
          title: constants.MENU_LIST.BAOCAO_QLCV_RANKING_TRUNGBINHTHANG,
          reportType: constants.REPORT.QLCV.TYPE.RANKING_TRUNGBINHTHANG
        })
      );
    },

    viewReportDetail(event) {

      let config = event.config;
      let routerName;
      let query;

      switch (config.reportType) {
        case constants.REPORT.QLCV.TYPE.BAOCAOTIENDOHOANTHANHCV:
          routerName = "tienDoHoanThanhCv";
          break;
        case constants.REPORT.QLCV.TYPE.BAOCAOTONGHOPTHANG:
          routerName = "baoCaoTongHopThang";
          break;
        case constants.REPORT.QLCV.TYPE.RANKING_TONGHOP:
          routerName = "rankingTongHop";
          break;
        case constants.REPORT.QLCV.TYPE.RANKING_TRUNGBINHTHANG:
          routerName = "rankingTrungBinhThang";
          break;
      }

      this.$router.push({
        name: routerName,
        params: this.$route.params,
        query: utils.merge(this.$route.query, query)
      });
    }
  }
};
</script>

<style lang="css">
.pCardReport {
  height: 300px;
  margin-bottom: 24px;
  padding: 0 10px;
}

.pCardReport .body {
  height: calc(100% - 105px);
}

.pCardReport .title {
  max-width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 12px;
}

.pCardReport .scroll-body {
  height: 100%;
}

.pCardReport .file-name {
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/views/report/tk-report-card.vue